import type { IComponentController } from "angular";

export class LoadingComponentController implements IComponentController {
    public static $inject = ["$log"];

    public isLoading: boolean;

    public extraClasses: string;
}
